import { DiscountPrice } from '@vp/swan';
import React, { useState, useEffect } from 'react';
import { useLocalization } from './src-hooks-useLocalizations.js';
import { calculateTotalSavings, isDiscounted } from './src-util-price-calculator-helper.js';

const Savings = ({ prices, priceProperties }) => {
  const [totalSavingsMessage, setTotalSavingsMessage] = useState("");
  const [totalSaving, setTotalSaving] = useState(0);
  const { t } = useLocalization();
  useEffect(() => {
    if (!prices) return;
    const result = calculateTotalSavings(
      prices.unitListPrice,
      prices.unitDiscountedPrice,
      prices.unitListPriceForMoq,
      priceProperties.currency,
      priceProperties.vatInc
    );
    setTotalSaving(result);
  }, [prices, priceProperties]);
  useEffect(() => {
    if (totalSaving > 0) {
      const message = isDiscounted(prices.totalListPrice, prices.totalDiscountedPrice, priceProperties.vatInc) ? t("price-platform.volume-discount-sale", { 0: totalSaving.toString() }) : t("price-platform.volume-discount.value", { 0: totalSaving.toString() });
      setTotalSavingsMessage(message);
    }
  }, [totalSaving]);
  if (totalSaving === 0) return null;
  return totalSavingsMessage ? /* @__PURE__ */ React.createElement(DiscountPrice, null, totalSavingsMessage) : null;
};

export { Savings as default };
//# sourceMappingURL=src-components-Savings.js.map
